module.exports = __webpack_public_path__ + "img/Group 105@2x.9cd6b443.png";